import { useIntl } from "react-intl";

const TeamCalendars = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.teamCalendars.header",
            defaultMessage: "Team calendars"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.teamCalendars.content",
            defaultMessage:
                "Share and embed team calendars. This can help teams communicate availability and stay organized."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.teamCalendars.altText",
            defaultMessage: "Example of a team calendar"
        }),
        caption: intl.formatMessage({
            id: "ConfluencePricingPage.features.teamCalendars.caption",
            defaultMessage:
                "Here’s what a team calendar looks like in Confluence."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Team-Calendars.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.caption}</p>
        </>
    );
};

export default TeamCalendars;
